import { createSelector } from 'reselect';

const complaintsSelector = createSelector(
  (state) => state.complaints,
  (complaints) => complaints,
);

export const isLoading = createSelector(complaintsSelector, (complaints) => complaints.isLoading);

export const isUpdating = createSelector(complaintsSelector, (complaints) => complaints.isUpdating);

export const list = createSelector(complaintsSelector, (complaints) => complaints.list);

export const detail = createSelector(complaintsSelector, (complaints) => complaints.detail);

export const error = createSelector(complaintsSelector, (complaints) => complaints.error);

export const conflict = createSelector(complaintsSelector, (complaints) => complaints.conflict);

export const success = createSelector(complaintsSelector, (complaints) => complaints.success);

// Host
export const hostList = createSelector(complaintsSelector, (complaints) => complaints.hostList);

export const hostDetail = createSelector(complaintsSelector, (complaints) => complaints.hostDetail);

export const hostIsLoading = createSelector(
  complaintsSelector,
  (complaints) => complaints.hostIsLoading,
);

export default complaintsSelector;
